import React, { useState, useCallback, SyntheticEvent } from 'react';
import classNames from 'classnames';

import styles from './Image.module.scss';

interface ImageProps {
  alt: string;
  className?: string | null;
  onLoad?: (event: SyntheticEvent<HTMLImageElement>) => void;
  onError?: (event: SyntheticEvent<HTMLImageElement>) => void;
  fade?: boolean;
  src?: string | null;
  placeholderSrc?: string | null;
  [key: string]: unknown;
}

const Image = ({
  className = null,
  fade = false,
  alt,
  onLoad = () => {},
  onError = () => {},
  src = null,
  placeholderSrc = null,
  ...rest
}: ImageProps) => {
  const [loaded, setLoaded] = useState(false);
  const onLoadOverride = useCallback(
    (event: SyntheticEvent<HTMLImageElement>) => {
      setLoaded(true);
      onLoad(event);
    },
    [onLoad, setLoaded],
  );

  return (
    <span data-testid="image-span">
      <img
        alt={alt}
        className={classNames(className, {
          [styles.hide]: !loaded,
          [styles.show]: loaded,
          [styles.fade]: fade,
        })}
        onLoad={onLoadOverride}
        onError={onError}
        src={src ?? undefined}
        data-testid="provided-image"
        {...rest}
      />
      {placeholderSrc && (
        <img
          alt={`${alt} placeholder`}
          className={classNames(
            className,
            {
              [styles.hide]: loaded,
              [styles.show]: !loaded,
              [styles.fade]: fade,
            },
            'position-absolute',
          )}
          style={{ left: 0, top: 0 }}
          src={placeholderSrc}
          data-testid="placeholder-image"
          {...rest}
        />
      )}
    </span>
  );
};

export default Image;
